var CustomerUserAuthorizationRole;
(function (CustomerUserAuthorizationRole) {
    CustomerUserAuthorizationRole["DEFAULT"] = "DEFAULT";
    CustomerUserAuthorizationRole["MODERATOR"] = "MODERATOR";
    CustomerUserAuthorizationRole["ADMINISTRATOR"] = "ADMINISTRATOR";
    CustomerUserAuthorizationRole["CONSULTANT"] = "CONSULTANT";
    CustomerUserAuthorizationRole["DEVELOPER"] = "DEVELOPER";
})(CustomerUserAuthorizationRole || (CustomerUserAuthorizationRole = {}));
export default CustomerUserAuthorizationRole;
